import { render } from "./OrderAreaCreateComponent.vue?vue&type=template&id=020759ab"
import script from "./OrderAreaCreateComponent.vue?vue&type=script&lang=js"
export * from "./OrderAreaCreateComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/ShippingSetup/OrderArea/OrderAreaCreateComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "020759ab"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('020759ab', __exports__)) {
    api.reload('020759ab', __exports__)
  }
  
  module.hot.accept("./OrderAreaCreateComponent.vue?vue&type=template&id=020759ab", () => {
    api.rerender('020759ab', render)
  })

}


export default __exports__